import {Component, inject} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {RouterLink} from '@angular/router';
import {AuthService} from '../../../core/auth-service';
import {DrawerService} from '../../../services/drawer-service';

@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  public readonly authService = inject(AuthService);
  public readonly drawerService = inject(DrawerService);

  logout(): void {
    this.authService.logout();
  }

  toggleDrawerState() {
    this.drawerService.state.set(!this.drawerService.state())
  }
}
